import { render } from "./MainHeader.vue?vue&type=template&id=33288676"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"
script.render = render

export default script